export interface McpMenuItemConfig {
  icon: string;
  id: 'mcp-command' | 'mcp-config' | 'mcp-cursor' | 'mcp-vscode';
  labelKey: 'ai.mcp.command' | 'ai.mcp.config' | 'ai.mcp.cursor' | 'ai.mcp.vscode';
  optionKey: 'command' | 'config' | 'cursor' | 'vscode';
}

export const mcpMenuItemsConfig: McpMenuItemConfig[] = [
  { id: 'mcp-cursor', icon: 'cursor', labelKey: 'ai.mcp.cursor', optionKey: 'cursor' },
  { id: 'mcp-vscode', icon: 'vscode', labelKey: 'ai.mcp.vscode', optionKey: 'vscode' },
  { id: 'mcp-config', icon: 'clipboard', labelKey: 'ai.mcp.config', optionKey: 'config' },
  { id: 'mcp-command', icon: 'terminal', labelKey: 'ai.mcp.command', optionKey: 'command' },
];
